import { CSVColumnDefinition } from '../models/CSVColumnDefinition';

export function generateCSV<T>(
  data: T[],
  columns: CSVColumnDefinition<T>[]
): string {
  if (data.length === 0) {
    return '';
  }

  // Generate header row
  const headers = columns.map(col => escapeCSVValue(col.label));
  const headerRow = headers.join(',');

  // Generate data rows
  const dataRows = data.map(row => {
    return columns.map(col => {
      const value = col.csvFormatter 
        ? col.csvFormatter(row)
        : (row as any)[col.key];
      return escapeCSVValue(value);
    }).join(',');
  });

  return [headerRow, ...dataRows].join('\n');
}

function escapeCSVValue(value: any): string {
  if (value === null || value === undefined) {
    return '';
  }

  const stringValue = String(value);
  
  // If the value contains comma, newline, or quote, wrap in quotes and escape quotes
  if (stringValue.includes(',') || stringValue.includes('\n') || stringValue.includes('"')) {
    return `"${stringValue.replace(/"/g, '""')}"`;
  }
  
  return stringValue;
}
